import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

type DividendBounceRetryFilterWarningProps = {
  allowedEmails: string[];
};

const DividendBounceRetryFilterWarning: FC<
  DividendBounceRetryFilterWarningProps
> = ({ allowedEmails }) => {
  const { t } = useTranslate();

  return (
    <div
      className="alert alert-warning mb-3"
      data-testid="dividend-bounce-retry-warning"
    >
      <strong>{t('DividendBounceRetryFilterWarningTitle')}</strong>
      <p className="mb-2">{t('DividendBounceRetryFilterWarningDescription')}</p>
      <ul className="mb-0 pl-3">
        {allowedEmails.map((email) => (
          <li key={email}>{email}</li>
        ))}
      </ul>
    </div>
  );
};

export default DividendBounceRetryFilterWarning;
